// Vendor libraries
import { ElementRef, NgZone } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
// Directives
import { PopoverBaseDirective } from 'NewAngular/features/directives/popovers/base/popover-base.directive';
import * as i0 from "@angular/core";
import * as i1 from "@angular/platform-browser";
/**
 * Popover Directive
 *
 * Extends the base popover directive and sets the event listeners to be on click for showing and on blur for hiding
 *
 */
export class PopoverDirective extends PopoverBaseDirective {
    constructor(el, sanitizer, ngZone) {
        super(el, sanitizer);
        this.el = el;
        this.ngZone = ngZone;
        this.ngZone.runOutsideAngular(() => {
            this.el.nativeElement.addEventListener('click', () => {
                this.toggleTooltip();
            });
            this.el.nativeElement.addEventListener('mouseenter', () => {
                this.hideTooltip();
            });
        });
    }
    isTooltip() {
        return false;
    }
}
PopoverDirective.ɵfac = function PopoverDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PopoverDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.DomSanitizer), i0.ɵɵdirectiveInject(i0.NgZone)); };
PopoverDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: PopoverDirective, selectors: [["", "ycnPopover", ""]], standalone: false, features: [i0.ɵɵInheritDefinitionFeature] });
